import { useLingui } from '@lingui/react/macro'

import { DialogHeader } from '@/layouts/Dialog'
import { StayForm } from '@/features/stay'
import { useCloseModal } from '@/Router'

export default function CreateStay() {
  const { t } = useLingui()
  const closeModal = useCloseModal()

  return (
    <div className="flex flex-col gap-7 p-5">
      <DialogHeader
        title={t`Create Stay`}
        description={t`Create a new guest stay`}
      />
      <StayForm onCancel={closeModal} onDone={closeModal} />
    </div>
  )
}
